<template>
  <dynamic-fields-menu>
    <template #header>
      <input v-model="q" type="text" placeholder="Search">
    </template>
    <template #body>
      <scroll-area class="dynamic-box">
        <hr>
        <div v-for="input in certificateDynamicInputs">
          <button
            class="field-item"
            v-if="input.type === CertificateDynamicInputType.Text"
            type="button"
            @click="select({id: input.client_id, additionalClasses: additionalClasses(input) ,label: input.name, type: DynamicReferenceType.CertificateMapping})">
            <icon v-if="input.parent.type === CertificateDynamicInputType.Object"glyph="infinity"></icon>
            {{input.name}}
          </button>
          <div
            v-else-if="(input.type === CertificateDynamicInputType.Repeatable)"
            class="collapse-item" :id="`element_${input.client_id}`">
            <button
              data-toggle="collapse"
              :href="`#repeatable_collapse_${input.client_id}`"
              role="button"
              :aria-expanded="isOpen([input]).toString()"
              :aria-controls="`${input.name}Collapse`"
              :class="`field-item ${{disabled: !isPresent([input]), collapsed: !isOpen([input])}}`">
              {{input.name}}
            </button>
            <div class="collapse" :class="{show: isOpen([input])}"
                 :id="`repeatable_collapse_${input.client_id}`">
              <button
                v-for="(_, index) in Array(20)"
                @click="select({id: input.client_id, label: `${input.name}.${index + 1}`, index: index, type: DynamicReferenceType.CertificateMapping})"
                type="button"
                class="field-item">
                {{input.name}}.{{index + 1}}
              </button>
            </div>
          </div>
          <hr>
        </div>
      </scroll-area>
    </template>
    <template #footer>
      <button @click="createInputAndGoTo" class="btn-link btn-block">+ Add New Dynamic Input</button>
    </template>
  </dynamic-fields-menu>
</template>

<script lang="ts">
  import Vue from "vue";
  import DynamicFieldsMenu from "../../../../common/components/dynamicFieldsTrees/dynamicFieldsMenu.vue";
  import Certificate from "../../models/certificate";
  import {CertificateDynamicInputType} from "../../enums/certificateDynamicInputType";
  import {InstanceHelper} from "../../../../common/helpers/instanceHelper";
  import {DynamicReferenceType} from "../../../../common/enums/dynamicReferenceType";
  import CertificateDynamicInput from "../../models/certificateDynamicInput";
  import CertificateElement from "../../models/certificateElement";

  export default Vue.extend({
    components: {
      DynamicFieldsMenu
    },
    props: {
      certificate: {
        type: Object as () => Certificate,
        required: true
      },
      certificateElement:{
        type: Object as () => CertificateElement
      },
      includeNested: {
        type: Boolean,
        default: true,
      },
    },
    data: function () {
      return {
        q: '',
        CertificateDynamicInputType,
        DynamicReferenceType
      };
    },
    methods: {
      select(config): void {
        this.$emit('select', config);
      },
      additionalClasses(input: CertificateDynamicInput) : string{
        return this.nestedRepeatableTextInputs.includes(input) ? "repeatable" : ""
      },
      createInputAndGoTo(): void {
        const input = this.certificate.createEmbeddedObject.certificate_dynamic_inputs(this.certificate);
        this.$router.push({name: 'inputs', hash: `#dynamic_input_name_${input.client_id}`});
      },
      isOpen(item: Array<any> | boolean = null): boolean {
        if (!this.hasSearched) {
          return false;
        }
        return InstanceHelper.isPresent(item);
      },
      isPresent(item: Array<any> | boolean): boolean {
        return InstanceHelper.isPresent(item);
      },
    },
    computed: {
      nestedRepeatableTextInputs(): CertificateDynamicInput[] | [] {
        if (!this.includeNested) {
          return []
        }

        const nestedInputs = []
        if (this.certificate.isDynamicLayout && this.certificateElement.layoutElementContainer.is_repeatable && !!this.certificateElement.layoutElementContainer.repeatable_input_id) {
          let parentGrid =  this.certificateElement.layoutElementContainer
          while(!!parentGrid){
            nestedInputs.push(...parentGrid.certificateDynamicInput.certificateDynamicInputs.filter(nestedInput => nestedInput.type === CertificateDynamicInputType.Text))
            parentGrid = parentGrid.parentGrid
          }
          return nestedInputs
        } else {
          return []
        }
      },
      certificateDynamicInputs(): CertificateDynamicInput[] {
        const toScan = this.certificate.certificateDynamicInputs;
        const inputs = [];

        inputs.push(...this.nestedRepeatableTextInputs)

        while (toScan.length > 0) {
          const input = toScan.shift();
          switch (input.type) {
            case CertificateDynamicInputType.Text:
              // intentional fallthrough
            case CertificateDynamicInputType.Repeatable:
              if (!input.is_list && input.name.toLowerCase().includes(this.q.toLowerCase())) {
                inputs.push(input);
              }
              break;
            case CertificateDynamicInputType.Image:
              break;
            case CertificateDynamicInputType.Object:
              if (!input.is_list) {
                toScan.push(...input.certificateDynamicInputs);
              }
              break;
          }
        }
        return inputs;
      }
    }
  });

</script>